import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, " Who is this claim for? ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.patients?.rows)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_DataTable, {
            type: "radio",
            classes: "striped small",
            table: _ctx.patients,
            selected: _ctx.patient,
            onChange: _ctx.handleChange
          }, null, 8, ["table", "selected", "onChange"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("a", {
      href: "",
      class: "btn btn-secondary plan-modal add-dependent",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAdd && _ctx.handleAdd(...args)), ["prevent"]))
    }, " + Add Dependent ")
  ], 64))
}